/**
 * @generated SignedSource<<5df3a9fc42f95d5884f2f70d06c44ff3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteNoteModal_note$data = {
  readonly createdAt: string | null;
  readonly eventEnd: string | null;
  readonly eventStart: string | null;
  readonly id: string;
  readonly meetingRecordings: ReadonlyArray<{
    readonly clips: ReadonlyArray<{
      readonly id: string;
      readonly title: string;
    }> | null;
    readonly hasTranscript: boolean | null;
    readonly id: string;
    readonly meetingRecordedVideoUrl: string | null;
  }> | null;
  readonly stream: {
    readonly id: string;
  };
  readonly title: string;
  readonly " $fragmentType": "DeleteNoteModal_note";
};
export type DeleteNoteModal_note$key = {
  readonly " $data"?: DeleteNoteModal_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteNoteModal_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteNoteModal_note",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasTranscript",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingRecordedVideoUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecordingClip",
          "kind": "LinkedField",
          "name": "clips",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "9b294b1871cd53b92ef6ab9e91d4d56b";

export default node;
